
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import { Section, Container, Heading, TextBlock, Main } from '@ui'
import useTranslation from 'next-translate/useTranslation'

export default function Page() {
    const { t, lang } = useTranslation('common')

    return (
        <Main className="bg-sand-light m:bg-white">
            <Section className="Section--text-page">
                {lang === 'ru' && (
                    <>
                        <Container className="pt-13 m:pt-19 pb-20 m:pb-18">
                            <div className="mb-5 m:mb-12 m:-mx-6 m:py-6 m:px-6 m:bg-sand-light">
                                <Heading
                                    text="rdПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ ВЕБ-САЙТА ЗАО TREVIO"
                                    className="m:hidden"
                                    size="s"
                                    component="h1"
                                />
                            </div>
                            <TextBlock className="mb-9 m:mb-12 rich">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: `
                            <h2>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ ВЕБ-САЙТА ЗАО TREVIO</h2>
                            <h3>1. Политика конфиденциальности </h3>
                            <p>
                                В нашей политике конфиденциальности Вы найдете ответы на самые важные вопросы о том, как мы собираем, используем и храним информацию о Вас. Если у Вас есть вопросы, мы готовы Вам помочь, как описано ниже.
                            </p>
                            <p>
                                Пожалуйста, внимательно прочитайте наши Политики конфиденциальности:
                            </p>
                            <p>
                                Политика конфиденциальности для посетителей нашего сайта
                                <br>Политика использования файлов cookie
                                <br>Политика конфиденциальности для лиц, отправляющих запросы
                                <br>Политика конфиденциальности в области прямого маркетинга
                                <br>Политика конфиденциальности персональных данных, обрабатываемых для таможенного оформления посылок
                            </p>
                            <h3>2. Наши контакты</h3>
                            <p>
                                Если у Вас есть вопросы, комментарии или жалобы относительно того, как мы собираем, используем и храним информацию о Вас, мы готовы Вам помочь. Если Вам нужна наша помощь, пожалуйста, обращайтесь по эл. почте: info@deklaruok24.lt
                            </p>
                            <h3>3. Мои права</h3>
                            <p>
                                Если хотите предпринять указанные ниже действия, пожалуйста, обращайтесь по контактам, указанным во втором пункте. Пожалуйста, обратите внимание, что к этим правам применяются условия и исключения, предусмотренные законодательством:
                            </p>
                            <ul>
                                <li>
                                подать прошение о раскрытии имеющейся информации о Вас;
                                </li>
                                <li>
                                подать прошение об исправлении имеющейся информации о Вас;
                                </li>
                                <li>
                                подать прошение об удалении имеющейся информации о Вас;
                                </li>
                                <li>
                                подать прошение об ограничении доступа к имеющейся о Вас информации или ее удалении;
                                </li>
                                <li>
                                не давать согласие на сбор, использование и хранение Вашей информации в нашей компании;
                                </li>
                                <li>
                                подать прошение об экспорте Ваших данных или их переносе в другую компанию;
                                </li>
                                <li>
                                подать жалобу в Государственную инспекцию по защите данных (подробная информация на lrv.lt).
                                </li>
                            </ul>
                            <h2>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ ДЛЯ ПОСЕТИТЕЛЕЙ САЙТА ЗАО TREVIO</h2>
                            <p>Дата последнего обновления: 18.11.2021</p>
                            <p>
                            ЗАО Trevio заботится о защите Вашей информации. Мы соблюдаем требования Общего регламента Европейского Союза по защите данных (ОРЗД) и других законов, защищающих Вашу персональную информацию, которую собираем, используем и храним в своей компании.
                            </p>
                            <h3>1. Как я должен читать эту Политику конфиденциальности?</h3>
                            <p>
                            В этой Политике конфиденциальности даны ответы на самые важные вопросы о том, как мы собираем, используем и храним информацию о Вас. Если у Вас есть какие-либо вопросы или какая-либо часть этого уведомления неясна, мы готовы Вам помочь, как описано в разделе 10 этой Политики конфиденциальности. Пожалуйста, обратите внимание, что любая форма слова «мы» в Политике конфиденциальности означает нашу Компанию, как указано в разделе 2 Политики конфиденциальности.
                            </p>
                            <h3>
                            2. Кто отвечает за защиту моей информации?
                            </h3>
                            <p>
                            Мы: ЗАО Trevio;
                            <br>Код юридического лица: 305433599;
                            <br>Наш адрес: ул. Йогайлос 9, Вильнюс;
                            <br>Адрес эл. почты: info@deklaruok24.lt;
                            </p>
                            <h3>
                            3. Почему вы собираете информацию обо мне?
                            </h3>
                            <p>
                            Мы предоставляем доступ к веб-сайту deklaruok24.lt, поддерживаем и улучшаем его, обеспечиваем его надлежащее функционирование. По этим причинам мы используем файлы cookie. Подробную информацию о файлах cookie, используемых на нашем сайте, и об их назначении можете найти в Политике использования файлов cookie.
                            </p>
                            <h3>
                            4. Используете ли вы файлы cookie?
                            </h3>
                            <p>
                            Да. На своем сайте deklaruok24.lt мы используем файлы cookie, как указано в Политике  использования файлов cookie.
                            </p>
                            <p>
                            У нас нет возможности использовать файлы cookie в своих аккаунтах социальных сетей, однако сами социальные сети, в которых у нас есть аккаунты, их используют. Подробную информацию о том, как владельцы социальных сетей, которыми мы пользуемся, используют и хранят информацию о Вас, можете найти, нажав на указанные ниже ссылки:
                            </p>
                            <ul>
                            <li>
                            Политика конфиденциальности Facebook;
                            </li>
                            <li>
                            </li>
                            Политика конфиденциальности Instagram.
                            </ul>
                            <h3>
                            5. Какое правовое основание для сбора информации обо мне?
                            </h3>
                            <p>
                            Мы собираем информацию о Вас законно, так как:
                            </p>
                            <ul>
                            <li>
                            мы имеем законную заинтересованность в использовании файлов cookie, необходимых для надлежащей работы сайта и его функций (п. f ч. 1 ст. 6 ОРЗД);
                            </li>
                            <li>
                            мы основываемся на Вашем согласии на использование аналитических и рекламных файлов cookie (п.a ч. 1 ст. 6 ОРЗД).
                            </li>
                            </ul>
                            <h3>
                            6. Делитесь ли вы информацией обо мне с другими субъектами?
                            </h3>
                            <p>
                            Можем делиться информацией с нашими поставщиками услуг, оказывающим нам услуги в области IT, услуги по обслуживанию и поддержке сайта, услуги хостинга
                            </p>
                            <h3>
                            7. Сколько времени вы храните информацию обо мне?
                            </h3>
                            <p>
                            Информацию, связанную с файлами cookie, храним, как указано в Политике использования файлов cookie.
                            </p>
                            <h3>
                            8. Какие действия могу предпринять в отношении своей информации, хранящейся в вашей компании?
                            </h3>
                            <p>
                            Если хотите предпринять указанные ниже действия, пожалуйста, обращайтесь к нам, как указано в разделе 9. Пожалуйста, обратите внимание, что к этим правам применяются условия и исключения, предусмотренные законодательством.
                            </p>
                            <ul>
                                <li>подать прошение об ознакомлении с имеющейся информацией о Вас, если обрабатываем Ваши персональные данные, на основании которых можем установить Вашу личность;</li>
                                <li>подать прошение об исправлении или дополнении имеющей информации о Вас;</li>
                                <li>подать прошение об удалении информации о Вас, если:</li>
                                <ul>
                                    <li>Ваши данные обрабатываем на основании согласия;</li>
                                    <li>Ваши данные обрабатываем незаконно;</li>
                                    <li>Ваши данные обрабатываем на основании нашего законного интереса, и Вы оспариваете наш законный интерес;</li>
                                    <li>Ваши данные больше не нужны для достижения целей, с которыми они собирались;</li>
                                    <li>У нас есть правовая обязанность удалить информацию о Вас;</li>
                                </ul>
                                <li>подать нам прошение об ограничении обработки имеющейся информации о Вас, когда оспариваете точность данных или возражаете против обработки данных, не соглашаетесь с удалением своих незаконно обрабатываемых данных или данных, которые Вам нужны, чтобы заявить, выполнить или защитить законные требования;</li>
                                <li>не соглашаться со сбором, использованием и хранением Вашей информации в нашей компании, когда, обрабатывая Ваши данные, руководствуемся законным интересом как основанием для обработки данных;</li>
                                <li>подать прошение на экспорт Ваших данных, если данные нам представили в систематизированном, обычно используемом формате и дали согласие на обработку таких данных или мы должны обрабатывать эти данные с целью выполнения договора с Вами;</li>
                                <li>в любой момент отозвать свое согласие на обработку своих персональных данных (это можете сделать, изменив настройки браузера &ndash; нажав на эту ссылку, найдете инструкции, как это сделать в самых популярных браузерах);</li>
                                <li>подать жалобу в Государственную инспекцию по защите данных (подробная информация на lrv.lt).</li>
                            </ul>
                            <h3>9. Как можете мне помочь?</h3>
                            <p>Если у Вас есть вопросы, комментарии или жалобы, связанные с тем, как мы собираем, используем и храним данные о Вас, мы готовы Вам помочь. Если Вам необходима наша помощь, пожалуйста, обращайтесь по эл. почте: info@deklaruok24.lt.</p>
                            <h2>Политика использования файлов cookie ЗАО TREVIO </h2>
                            <p>Дата последнего обновления: 18.11.2021</p>
                            <h3>1. Что такое файлы cookie?</h3>
                            <p>Файлы cookie &ndash; это маленькие текстовые файлы, которые хранятся в браузере Вашего устройства (например, на компьютере, мобильном телефоне, планшете), когда Вы посещаете веб-сайты. Другие технологии, включая данные, которые сохраняются в Вашем браузере или устройстве, идентификаторы, связанные с Вашим устройством, и другое программное обеспечение, используются для аналогичных целей. Файлы cookie широко используются для работы веб-сайтов или повышения их эффективности. В этой политике все упомянутые технологии называются &laquo;cookie&raquo;.</p>
                            <h3>4. Почему мы используем cookie?</h3>
                            <p>Мы используем файлы cookie:</p>
                            <ul>
                            <li>для постоянного улучшения сайта, чтобы он был для вас более привлекательным;</li>
                            </ul>
                            <h3>4. Какие типы файлов cookie бывают?</h3>
                            <ul>
                            <li>
                            Строго обязательные файлы cookie
                            <p>Эти файлы являются обязательными, чтобы пользователь мог осуществлять поиск и пользоваться функциями сайта, например, запоминать информацию, указанную в формах, когда пользователь переходит с одной страницы на другую во время сеанса поиска. Без строго обязательных файлов cookie было бы невозможно оказывать определенные услуги на сайте, а сайт работал бы не так слаженно, как должен. Эти файлы cookie не собирают никакой информации в целях маркетинга и не запоминают, какие сайты вы посещали в интернете.</p>
                            </li>
                            </ul>
                            <ul>
                            <li>Аналитические файлы cookie
                            <p>Аналитические файлы cookie собирают информацию об использовании сайта &nbsp;и помогают улучшать работу сайта. Например, аналитические файлы cookie могут показать, какие страницы Вы посещаете чаще всего, помогают регистрировать неполадки, происходящие на сайте, и показать, эффективна ли реклама, отображаемая на сайте. Аналитические файлы cookie не собирают личную информацию пользователей, вся информация, собранная этими файлами, является обобщенной и анонимной.</p>
                            </li>
                            </ul>
                            <ul>
                            <li>Функциональные файлы cookie
                            <p>Функциональные файлы cookie позволяют сайту запомнить Ваши настройки и предложить улучшенные функции, более подходящие Вашим потребностям. Функциональные файлы cookie также запоминают сделанные вами изменения, например, персонализацию определенной веб-страницы, а также в других случаях, например, когда смотрите видеозапись или на нашем сайте оставляете комментарий. Функциональные файлы cookie не отслеживают Ваши действия на других сайтах.</p>
                            </li>
                            </ul>
                            <ul>
                            <li>Рекламные файлы cookie
                            <p>Рекламные файлы cookie используются для показа более интересных объявлений, которые лучше соответствуют Вашим интересам, или для ограничения частоты показов одинаковых объявлений на сайте, который Вы посещаете. Этот тип файлов cookie также используется для оценки эффективности кампании. Эти файлы могут использоваться для запоминания Ваших действий на сайте.</p>
                            </li>
                            </ul>
                            <h3>5. Какие файлы cookie используем мы?</h3>
                            <p>На своем сайте мы используем следующие файлы cookie:</p>
                            <table>
                            <tbody>
                            <tr>
                            <td width="121">
                            <p>КАТЕГОРИЯ ФАЙЛА COOKIE</p>
                            </td>
                            <td width="212">
                            <p>НАЗВАНИЕ ФАЙЛА COOKIE</p>
                            </td>
                            <td width="119">
                            <p>СРОК ДЕЙСТВИЯ&nbsp; ФАЙЛА COOKIE</p>
                            </td>
                            <td width="189">
                            <p>ЦЕЛЬ ФАЙЛА COOKIE</p>
                            </td>
                            </tr>
                            <tr>
                            <td rowspan="7" width="121">
                            <p>Аналитические файлы cookie</p>
                            </td>
                            <td width="212">
                            <p>_hjAbsoluteSessionInProgress</p>
                            </td>
                            <td width="119">
                            <p>30 &ndash; 35 минут</p>
                            </td>
                            <td width="189">
                            <p>Файл cookie первой стороны HotJar используется для обнаружения первого сеанса просмотра страницы пользователем.</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="212">
                            <p>_hjFirstSeen</p>
                            </td>
                            <td width="119">
                            <p>30 &ndash; 35 минут</p>
                            </td>
                            <td width="189">
                            <p>Файл cookie первой стороны HotJar предназначен для идентификации HotJar первого сеанса нового пользователя.</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="212">
                            <p>_hjTLDTest</p>
                            </td>
                            <td width="119">
                            <p>До окончания сессии поиска (закрытия браузера)</p>
                            </td>
                            <td width="189">
                            <p>Файл cookie первой стороны HotJar предназначен для определения лучшего использования файлов HotJar. Это делается для того, чтобы файлы cookie работали на субдоменах сайта.</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="212">
                            <p>_hjid</p>
                            </td>
                            <td width="119">
                            <p>1 год</p>
                            </td>
                            <td width="189">
                            <p>Файл cookie первой стороны HotJar предназначен для присвоения уникального ID каждому уникальному пользователю сайта.</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="212">
                            <p>_ga</p>
                            </td>
                            <td width="119">
                            <p>2 года</p>
                            </td>
                            <td rowspan="3" width="189">
                            <p>Файлы cookie первой стороны Google предназначены для сбора информации о посещаемости сайта и о том, как наши посетители пользуются сайтом. Файлы cookie собирают такую информацию, как количество посетителей сайта, сайт, с которого зашли посетители, страницы, посещенные на сайте, браузер, используемый для поиска, операционная система и т.п.</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="212">
                            <p>_gat_gtag_UA_xxxxxxxxx_x</p>
                            </td>
                            <td width="119">
                            <p>1 минута</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="212">
                            <p>_gid</p>
                            </td>
                            <td width="119">
                            <p>1 день</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="121">
                            <p>Функциональные файлы cookie</p>
                            </td>
                            <td width="212">
                            <p>trevioCookie</p>
                            </td>
                            <td width="119">
                            <p>1 год</p>
                            </td>
                            <td width="189">
                            <p>Файл cookie для настроек пользователей</p>
                            </td>
                            </tr>
                            <tr>
                            <td rowspan="2" width="121">
                            <p>Рекламные файлы cookie</p>
                            </td>
                            <td width="212">
                            <p>fr</p>
                            </td>
                            <td width="119">
                            <p>90 дней</p>
                            </td>
                            <td width="189">
                            <p>Файл cookie третьей стороны Facebook, предназначен для отображения рекламы, измерения конверсий рекламы и повышения актуальности отображаемой рекламы.</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="212">
                            <p>_fbp</p>
                            </td>
                            <td width="119">
                            <p>90 дней</p>
                            </td>
                            <td width="189">
                            <p>Файл cookie первой стороны Facebook, используется для определения браузера пользователя в целях аналитики сайта и отображения рекламы.</p>
                            </td>
                            </tr>
                            </tbody>
                            </table>
                            <h3>6. Как я могу управлять файлами </strong><strong>cookie?</h3>
                            <p>Можете контролировать использование файлов cookie, изменив настройки браузера. Подробная информация представлена на сайте создателя используемого браузера, а также, нажав на <a href="https://www.lifewire.com/how-to-delete-cookies-2617981">эту</a> ссылку, можете найти инструкции, как это сделать в самых популярных браузерах.</p>
                            <p>Обратите внимание, что, удаляя или отключая использование файлов cookie, в будущем можете не получить доступ к определенным частям или функциям нашего сайта. Если измените настройки файлов cookie, это повлияет и на другие сайты, которые посещаете.</p>
                            <h2>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ ЗАО TREVIO ДЛЯ ЛИЦ, ОТПРАВЛЯЮЩИХ ЗАПРОСЫ, ПРОШЕНИЯ, ЖАЛОБЫ </h2>
                            <p><strong>Дата последнего обновления: 18.11.2021</strong></p>
                            <p>ЗАО Trevio заботится о защите Вашей информации. Мы соблюдаем требования Общего регламента Европейского Союза по защите данных (ОРЗД) и других законов, защищающих Вашу персональную информацию, которую собираем, используем и храним в своей компании.</p>
                            <h3>1. Как я должен читать эту Политику конфиденциальности?</h3>
                            <p>В этой Политике конфиденциальности даны ответы на самые важные вопросы о том, как мы собираем, используем и храним информацию о Вас. Если у Вас есть какие-либо вопросы или какая-либо часть этого уведомления неясна, мы готовы Вам помочь, как описано в разделе 9 этой Политики конфиденциальности. Пожалуйста, обратите внимание, что любая форма слова &laquo;мы&raquo; в Политике конфиденциальности означает нашу Компанию, как указано в разделе 2 Политики конфиденциальности.</p>
                            <h3>2. Кто отвечает за защиту моей информации?</h3>
                            <p>Мы: ЗАО Trevio;
                            <br>Код юридического лица: 305433599;
                            <br>Наш адрес: ул. Йогайлос 9, Вильнюс;
                            <br>Адрес эл. почты: info@deklaruok24.lt;
                            </p>
                            <h3>3. Почему собираете информацию обо мне? Какое правовое основание для сбора, использования и хранения информации обо мне?</h3>
                            <table>
                            <tbody>
                            <tr>
                            <td width="263">
                            <p><strong>Цель сбора, использования, хранения данных </strong></p>
                            </td>
                            <td colspan="2" width="387">
                            <p><strong>Правовое основание сбора, использования, хранения данных </strong></p>
                            </td>
                            </tr>
                            <tr>
                            <td width="263">
                            <p>&middot; для надлежащего администрирования полученных &nbsp;запросов, прошений и жалоб, подготовки ответов на них</p>
                            </td>
                            <td width="47">
                            <p>-</p>
                            </td>
                            <td width="340">
                            <p>наша законная заинтересованность в администрировании получаемых прошений, жалоб, запросов и подготовке ответов на них (п. f ч. 1 ст. 6 ОРЗД), а когда такие прошения, запросы, жалобы связаны с исполнением заключенного договора или желанием заключить договор &ndash; то администрирование таких прошений, запросов или жалобы является обязательным для надлежащего исполнения заключенных нами договоров или для оценки возможности заключения с Вами договора (п. b ч. 1 ст. 6 ОРЗД);</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="263">
                            <p>&middot; наша правовая обязанность &nbsp;хранить документы о деятельности компании &nbsp;</p>
                            </td>
                            <td width="47">
                            <p>-</p>
                            </td>
                            <td width="340">
                            <p>Ваши персональные данные нужны нам для&nbsp; исполнения правовых обязанностей по архивированию документов по деятельности компании (п. с ч. 1 ст. 6 ОРЗД);</p>
                            </td>
                            </tr>
                            <tr>
                            <td width="263">
                            <p>&middot; для защиты своих законных интересов &ndash; если это необходимо, Ваши персональные данные можем использовать для защиты своих законных интересов, включая репутацию, в судах, органах досудебного решения споров и других компетентных органах</p>
                            </td>
                            <td width="47">
                            <p>-</p>
                            </td>
                            <td width="340">
                            <p>наша законная заинтересованность в защите &nbsp;своих прав и интересов в судах, арбитражах и органах досудебного рассмотрения споров (п. f ч. 1 ст. 6 ОРЗД).</p>
                            </td>
                            </tr>
                            </tbody>
                            </table>
                            <h3>4. Какую информацию я должен представить и почему?</h3>
                            <p>Отправляя запрос на адреса эл. почты, указанные на нашем сайте, через функционал прямого чата на сайте (англ.&nbsp;<em>chat bubble</em>) или по почте, Вы должны нам указать свое имя, фамилию, адрес эл. почты или иные контактные данные, посредством которых хотите получить ответ, а также тему запроса и актуальную информацию по запросу. Получив запрос, мы можем попросить Вас предоставить дополнительную информацию о себе, чтобы могли должным образом ответить на Ваш запрос.</p>
                            <h3>5. Собираете ли Вы чувствительную информацию обо мне?</h3>
                            <p>Чувствительную информацию о Вас не собираем и, если она неактуальна для прошения, запроса или жалобы, которую Вы направили или планируете направить, просим ее не предоставлять. Если все-таки такая информация будет представлена, будем считать, что Вы нам дали согласие на обработку этой информации (п. а ч. 1 ст. 9 ОРЗД).</p>
                            <h3>6. Делитесь ли </strong><strong>вы информацией обо мне с другими субъектами?</h3>
                            <p>Информация о Вас может быть передана:</p>
                            <ul>
                            <li>компаниям, оказывающим юридические услуги, адвокатским конторам, в том объеме, насколько это необходимо для защиты наших законных интересов;</li>
                            <li>приставам, насколько это необходимо для взыскания присужденных сумм;</li>
                            <li>нашим поставщикам услуг &ndash; компаниям, оказывающим нам коммуникационные услуги (эл. почта), услуги хостинга и хранилищ данных.</li>
                            </ul>
                            <h3>7. Сколько времени храните информацию обо мне?</h3>
                            <p>Ваша информация будет храниться:</p>
                            <ul>
                            <li>если Ваш запрос связан с договором, который заключили или планируете заключить &ndash; Вашу информацию будем хранить 10 лет после окончания договора;</li>
                            <li>если направили нам жалобу, прошение или иной запрос, который не связан с заключением или выполнением договора, информацию будем хранить, руководствуясь указателем общих сроков хранения документов, утвержденным Главным архивариусом Литвы, &nbsp;&ndash; 1 год со дня принятия решения в нашей компании;</li>
                            <li>документы, передаваемые судам и другим правоохранительным органам или другим органам, рассматривающим споры, хранятся 1 год после принятия окончательного решения;</li>
                            <li>судебные исполнительные листы, распоряжения приставов хранятся 10 лет после окончания платежей.</li>
                            </ul>
                            <h3>8. Какие действия могу </strong><strong>предпринять в отношении своей информации, хранящейся в вашей компании?</h3>
                            <p>Если хотите предпринять указанные ниже действия, пожалуйста, обращайтесь к нам, как указано в разделе 10. Пожалуйста, обратите внимание, что к этим правам могут применяться условия и исключения, предусмотренные законодательством.</p>
                            <ul>
                            <li><strong>подать прошение об ознакомлении с имеющейся информацией о Вас, если обрабатываем Ваши персональные данные, по которым можем установить Вашу личность;</strong></li>
                            <li><strong>подать прошение об исправлении или дополнении имеющейся информации о Вас;</strong></li>
                            <li><strong>подать прошение об удалении информации о Вас, если:</strong></li>
                            <li><strong>Ваши данные обрабатываем на основе согласия;</strong></li>
                            <li><strong>Ваши данные обрабатываем незаконно;</strong></li>
                            <li><strong>Ваши данные обрабатываются на основании нашего законного интереса, и Вы оспариваете наш законный интерес;</strong></li>
                            <li><strong>Ваши данные больше не нужны в тех целях, в которых они собирались;</strong></li>
                            <li><strong>у нас есть правовая обязанность удалить информацию о Вас;</strong></li>
                            <li><strong>подать нам прошение об ограничении обработки имеющейся информации о Вас, когда оспариваете точность данных или возражаете против обработки данных, не соглашаетесь, чтобы Ваши незаконно обрабатываемые данные были удалены, или данные нужны для заявления, выполнения или защиты правовых требований;</strong></li>
                            <li><strong>не соглашаться со сбором, использованием и хранением своей информации в нашей компании, когда, обрабатывая Ваши данные, руководствуемся законным интересом как основанием для обработки данных;</strong></li>
                            <li><strong>подать прошение об экспорте своих данных, если данные представили нам в систематизированном, обычно используемом формате и дали согласие на обработку таких данных или мы должны обрабатывать эти данные с целью выполнения договора с Вами;</strong></li>
                            <li><strong>в любое время отозвать согласие на обработку своих персональных данных;</strong></li>
                            <li><strong>подать жалобу в Государственную инспекцию по защите данных (подробная информация </strong><a href="https://vdai.lrv.lt/"><strong>lt</strong></a><strong>).</strong></li>
                            </ul>
                            <h3>9. Как можете мне помочь?</h3>
                            <p>Если у Вас есть вопросы, комментарии или жалобы, связанные с тем, как мы собираем, используем и храним данные о Вас, мы готовы Вам помочь. Если Вам необходима наша помощь, пожалуйста, обращайтесь по эл. почте: info@deklaruok24.lt.</p>
                            <h2>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ В ОБЛАСТИ ПРЯМОГО МАРКЕТИНГА ЗАО TREVIO </h2>
                            <p><strong>Дата последнего обновления: 18.11.2021</strong></p>
                            <p>ЗАО Trevio заботится о защите Вашей информации. Мы соблюдаем требования Общего регламента Европейского Союза по защите данных (ОРЗД) и других законов, защищающих Вашу персональную информацию, которую собираем, используем и храним в своей компании.</p>
                            <h3>1. Как я должен читать эту Политику конфиденциальности?</h3>
                            <p>В этой Политике конфиденциальности даны ответы на самые важные вопросы о том, как мы собираем, используем и храним информацию о Вас. Если у Вас есть какие-либо вопросы или какая-либо часть этого уведомления неясна, мы готовы Вам помочь, как описано в разделе 7 этой Политики конфиденциальности. Пожалуйста, обратите внимание, что любая форма слова &laquo;мы&raquo; в Политике конфиденциальности означает нашу Компанию, как указано в разделе 2 Политики конфиденциальности.</p>
                            <h3>2. Кто отвечает за защиту моей информации?</h3>
                            <p>Мы: ЗАО Trevio;
                            <br>Код юридического лица: 305433599;
                            <br>Наш адрес: ул. Йогайлос 9, Вильнюс;
                            <br>Адрес эл. почты: info@deklaruok24.lt;
                            </p>
                            <h3>3. Почему собираете информацию обо мне? Какое правовое основание для сбора, использования и хранения информации обо мне?</h3>
                            <table width="641">
                            <tbody>
                            <tr>
                            <td width="301">
                            <p><strong>Цель сбора, использования, хранения данных </strong></p>
                            </td>
                            <td colspan="2" width="340">
                            <p><strong>Правовое основание сбора, использования, хранения данных </strong></p>
                            </td>
                            </tr>
                            <tr>
                            <td width="301">
                            <p>&middot; чтобы могли по эл. почте рекламировать Вам свои услуги, отправлять наши предложения, новостные рассылки</p>
                            </td>
                            <td width="38">
                            <p>-</p>
                            </td>
                            <td width="302">
                            <p>для достижения этой цели мы руководствуемся Вашим согласием</p>
                            <p>(п. a ч. 1 ст. 6 ОРЗД)</p>
                            </td>
                            </tr>
                            </tbody>
                            </table>
                            <h3>4. Делитесь ли вы информацией обо мне с другими субъектами?</h3>
                            <p>Информация о Вас может быть передана нашим поставщикам услуг &ndash; поставщикам услуг в области маркетинговых платформ, хранилищ данных.</p>
                            <h3>5. Сколько времени будете хранить информацию обо мне?</h3>
                            <p>Информацию о Вас будем хранить 3 года или до отзыва Вашего согласия. Обратите внимание, что по окончании предусмотренного трехлетнего периода мы можем попросить Вас продлить согласие на более длительный период.</p>
                            <h3>6. Какие у меня права?</h3>
                            <p>Если хотите предпринять указанные ниже действия, пожалуйста, обращайтесь к нам, как указано в разделе 7. Обращаем внимание, что к этим правам могут применяться исключения и ограничения, предусмотренные законодательством.</p>
                            <ul>
                            <li><strong>подать прошение об ознакомлении с имеющейся информацией о Вас, если обрабатываем Ваши персональные данные, по которым можем установить Вашу личность;</strong></li>
                            <li><strong>подать прошение об исправлении или дополнении имеющейся информации о Вас;</strong></li>
                            <li><strong>подать прошение об удалении информации о Вас, если:</strong></li>
                            <li><strong>Ваши данные обрабатываем на основе согласия;</strong></li>
                            <li><strong>Ваши данные обрабатываем незаконно;</strong></li>
                            <li><strong>Ваши данные обрабатываются на основании нашего законного интереса, и Вы оспариваете наш законный интерес;</strong></li>
                            <li><strong>Ваши данные больше не нужны в тех целях, в которых они собирались;</strong></li>
                            <li><strong>у нас есть правовая обязанность удалить информацию о Вас;</strong></li>
                            <li><strong>подать нам прошение об ограничении обработки имеющейся информации о Вас, когда оспариваете точность данных или возражаете против обработки данных, не соглашаетесь, чтобы Ваши незаконно обрабатываемые данные были удалены, или данные нужны для заявления, выполнения или защиты правовых требований;</strong></li>
                            <li><strong>подать прошение об экспорте своих данных, если данные представили нам в систематизированном, обычно используемом формате и дали согласие на обработку таких данных или мы должны обрабатывать эти данные с целью выполнения договора с Вами;</strong></li>
                            <li><strong>в любое время отозвать согласие на обработку своих персональных данных;</strong></li>
                            <li><strong>подать жалобу в Государственную инспекцию по защите данных (подробная информация </strong><a href="https://vdai.lrv.lt/"><strong>lt</strong></a><strong>).</strong></li>
                            </ul>
                            <p><strong>Обращаем внимание, что Вы не можете воспользоваться правом не давать согласие на обработку своих персональных данных, поскольку этим правом можно воспользоваться только в тех случаях, когда персональные данные обрабатываются на основании законного интереса (п. f ч. 1 ст. 6 ОРЗД), а мы осуществляем обработку Ваших персональных данных на основании согласия (п. а ч. 1 ст. 6 ОРЗД).</strong></p>
                            <h3>7. Как можете мне помочь?</h3>
                            <p>Если у Вас есть вопросы, комментарии или жалобы, связанные с тем, как мы собираем, используем и храним данные о Вас, мы готовы Вам помочь. Если Вам необходима наша помощь, пожалуйста, обращайтесь по эл. почте: info@deklaruok24.lt.</p>
                            <h2>ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ ЗАО TREVIO В ОТНОШЕНИИ ПЕРСОНАЛЬНЫХ ДАННЫХ, ОБРАБАТЫВАЕМЫХ ДЛЯ ТАМОЖЕННОГО ОФОРМЛЕНИЯ&nbsp; ПОСЫЛОК</h2>
                            <p><strong>Дата последнего обновления: 18.11.2021</strong></p>
                            <p>ЗАО Trevio заботится о защите Вашей информации. Мы соблюдаем требования Общего регламента Европейского Союза по защите данных (ОРЗД) и других законов, защищающих Вашу персональную информацию, которую собираем, используем и храним в своей компании.</p>
                            <h3>1. Как я должен читать это уведомление?</h3>
                            <p>В настоящей Политике конфиденциальности даны ответы на самые важные вопросы о том, как мы собираем, используем и храним информацию о Вас. Если у Вас есть какие-либо вопросы или какая-либо часть этого уведомления неясна, мы готовы Вам помочь, как описано в разделе 9 этой Политики конфиденциальности. Пожалуйста, обратите внимание, что любая форма слова &laquo;мы&raquo; в Политике конфиденциальности означает нашу Компанию, как указано в разделе 2 Политики конфиденциальности.</p>
                            <h3>2. Кто отвечает за защиту моей информации?</h3>
                            <p>Обрабатывая персональные данные с целью таможенного оформления посылок, мы действуем как операторы данных своих клиентов. Владельцем данных, который отвечает за защиту Вашей информации, обычно является перевозчик посылки/посылок. ОРЗД не обязывает нас публично объявлять клиентов, от имени и в интересах которых мы обрабатываем персональные данные. Однако если у Вас есть вопросы, прошения или жалобы, связанные с обработкой Ваших персональных данных, можете обратиться к нам по указанным ниже контактам, а мы передадим Ваш запрос клиенту, который отвечает за защиту Ваших персональных данных. Обращаем внимание, что в определенных случаях можем попросить Вас сообщить дополнительную информацию, чтобы могли определить, кому должны передать Ваш запрос.</p>
                            <p>Наши контакты:
                            <br>Мы: ЗАО Trevio;
                            <br>Код юридического лица: 305433599;
                            <br>Наш адрес: ул. Йогайлос 9, Вильнюс;
                            <br>Адрес электронной почты: info@deklaruok24.lt;
                            </p>
                            <h3>3. Какую информацию о Вас мы получаем?</h3>
                            <p>От своих клиентов мы получаем следующую информацию о Вас:</p>
                            <ul>
                            <li>идентифицирующие данные (имя, фамилия);</li>
                            <li>контактные данные (адрес, адрес эл. почты, номер телефона);</li>
                            <li>данные о посылке (информация о товаре, представленная продавцом, т.е. товар, его цена, отправитель посылки, статус посылки, вес посылки и т.п.).</li>
                            </ul>
                            <p>Обращаем внимание, что если продавец не представил какую-либо информацию, напр.: адрес эл. почты, в таком случае такой информацией не будем располагать и мы.</p>
                            <h3>4. Сколько времени храните информацию обо мне?</h3>
                            <p>Как упомянуто в пункте 2, при обработке Ваших персональных данных мы действуем как оператор данных. Владелец данных (субъект, который отвечает за защиту Ваших персональных данных) устанавливает срок хранения Ваших персональных данных, согласно которому мы храним переданные нам персональные данные. Таким образом, собирая, используя и храня персональные данные, мы основываемся на указаниях, данных нашим клиентом (владельцем данных).</p>
                            `
                                    }}
                                />
                            </TextBlock>
                        </Container>
                    </>
                )}
                {lang !== 'ru' && (
                    <>
                        <Container className="pt-13 m:pt-19 pb-20 m:pb-18">
                            <div className="mb-5 m:mb-12 m:-mx-6 m:py-6 m:px-6 m:bg-sand-light">
                                <Heading
                                    text="TREVIO UAB INTERNETO PUSLAPIO PRIVATUMO POLITIKA"
                                    className="m:hidden"
                                    size="s"
                                    component="h1"
                                />
                                <Heading
                                    text="TREVIO UAB INTERNETO PUSLAPIO PRIVATUMO POLITIKA"
                                    className="hidden m:block"
                                    size="m"
                                    component="h1"
                                />
                            </div>
                            <TextBlock className="mb-9 m:mb-12 rich">
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: `
                        <h2>TREVIO UAB INTERNETO PUSLAPIO PRIVATUMO POLITIKA</h2>
                        <p>Trevio UAB rūpinasi Jūsų informacijos apsauga. Mes laikomės Europos Sąjungos Bendrojo duomenų apsaugos reglamento (BDAR) bei kitų įstatymų, saugančių Jūsų informaciją, kurią renkame, naudojame ir saugome savo Bendrovėje.</p>
                        <h3>
                           1. Privatumo politika
                        </h3>
                        <p>Mūsų privatumo politika atsakys į svarbiausius klausimus apie tai, kaip mes renkame, naudojame ir saugome informaciją apie Jus. Jei turite klausimų, mes esame pasirengę Jums padėti, kaip apra&scaron;yta toliau.</p>
                        <p>Pra&scaron;ome atidžiai perskaityti mūsų Privatumo politikas:</p>
                        <p>
                            <a href="#privacy-policy-for-users">Privatumo politika interneto svetainės lankytojams</a>
                            <br/><a href="#cookie-policy">Slapukų politika</a>
                            <br/><a href="#privacy-policy-for-inquirer">Privatumo politika paklausimus siunčiantiems asmenims</a>
                            <br/><a href="#direct-marketing-privacy-policy">Tiesioginės rinkodaros privatumo politika</a>
                            <br/><a href="#privacy-policy-for-broker-customers">Privatumo politika siuntų i&scaron;muitinimui tvarkomiems asmens duomenims</a>
                        </p>
                        <h3>2. Mūsų kontaktai</h3>
                        <p>Jei turite klausimų, komentarų ar skundų dėl to, kaip mes renkame, naudojame ir saugome informaciją apie jus, mes esame pasirengę Jums padėti. Jeigu Jums reikalinga mūsų pagalba, pra&scaron;ome kreiptis el. pa&scaron;tu info@deklaruok24.lt.</p>
                        <h3>3. Mano teisės</h3>
                        <p>Jei norite imtis žemiau nurodytų veiksmų, pra&scaron;ome kreiptis į mus antrame punkte nurodytais kontaktais. Pra&scaron;ome atkreipti dėmesį, jog &scaron;ioms teisėms taikomos įstatymų numatytos sąlygos ir i&scaron;imtys:</p>
                        <ul>
                           <li><strong>pateikti pra&scaron;ymą atskleisti apie Jus turimą informaciją;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;taisyti turimą informaciją apie Jus;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;trinti turimą informaciją apie Jus;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą apriboti prieigą prie turimos informacijos apie Jus ar jos i&scaron;trynimą;</strong></li>
                           <li><strong>nesutikti su Jūsų informacijos rinkimu, naudojimu ir saugojimu mūsų bendrovėje;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;eksportuoti Jūsų duomenis arba perkelti juos į kitą bendrovę;</strong></li>
                           <li><strong>pateikti skundą Valstybinei duomenų apsaugos inspekcijai (daugiau informacijos </strong><a href="https://vdai.lrv.lt/"><strong>lrv.lt</strong></a><strong>). </strong></li>
                        </ul>
                        <h2 id="privacy-policy-for-users">TREVIO UAB PRIVATUMO POLITIKA INTERNETO SVETAINĖS LANKYTOJAMS </h2>
                        <p><strong>Paskutinio atnaujinimo data: 2021-11-18</strong></p>
                        <p>Trevio UAB rūpinasi Jūsų informacijos apsauga. Mes laikomės Europos Sąjungos Bendrojo duomenų apsaugos reglamento (BDAR) bei kitų įstatymų, saugančių Jūsų informaciją, kurią renkame, naudojame ir saugome savo Bendrovėje.</p>
                        <h3>1. Kaip turėčiau skaityti &scaron;ią Privatumo politiką?</h3>
                        <p>&Scaron;ioje Privatumo politikoje bus atsakyta į svarbiausius klausimus apie tai, kaip mes renkame, naudojame ir saugome informaciją apie Jus. Jei turite kokių nors klausimų arba bet kuri i&scaron; &scaron;io prane&scaron;imo dalis yra neai&scaron;ki, mes esame pasirengę Jums padėti, kaip apra&scaron;yta &scaron;ios Privatumo politikos 10 skyriuje. Pra&scaron;ome atkreipti dėmesį, kad bet kokia žodžio &bdquo;mes&ldquo; forma &scaron;ioje Privatumo politikoje rei&scaron;kia mūsų Bendrovę, kaip nurodyta Privatumo politikos 2 skyriuje.</p>
                        <h3>2. Kas yra atsakingas už mano informacijos apsaugą?</h3>
                        <p>Mes esame: Trevio UAB;</p>
                        <p>Mūsų juridinio asmens kodas yra: 305433599;</p>
                        <p>Mūsų adresas: Naujoji 124-801, Alytus, LT62175;</p>
                        <p>El. pa&scaron;to adresas: info@deklaruok24.lt;</p>
                        <h3>3. Kodėl renkate informaciją apie mane?</h3>
                        <p>Mes teikiame vie&scaron;ą prieigą prie interneto svetainės deklaruok24.lt, ją palaikome bei tobuliname, užtikriname tinkamą jos funkcijų veikimą. Dėl &scaron;ių priežasčių mes naudojame slapukus. Daugiau informacijos apie mūsų interneto puslapyje naudojamus slapukus ir jų paskirtį galite rasti <a href="#cookie-policy">slapukų politikoje</a>.</p>
                        <h3>4. Ar naudojate slapukus?</h3>
                        <p>Taip. Mes savo interneto svetainėje deklaruok24.lt naudojame slapukus, kaip nurodyta <a href="#cookie-policy">Slapukų politikoje</a>.</p>
                        <p>Mes neturime galimybės naudoti slapukų savo socialinio tinklų paskyrose, tačiau patys socialiniai tinklai, kuriuose mes turime paskyras, juos naudoja. Daugiau informacijos apie tai, kaip mūsų naudojamų socialinių tinklų valdytojai renka, naudoja ir saugo informaciją apie Jus galite rasti paspaudę žemiau esančias nuorodas:</p>
                        <ul>
                           <li><a href="https://www.facebook.com/policy.php"><em>Facebook </em>privatumo politika</a>;</li>
                           <li><a href="https://help.instagram.com/519522125107875"><em>Instagram </em>privatumo politika</a>.</li>
                        </ul>
                        <h3>5. Koks yra teisinis informacijos apie mane rinkimo pagrindas?</h3>
                        <p>Mes renkame informaciją apie Jus teisėtai, nes:</p>
                        <ul>
                           <li>mes turime teisėtą interesą naudoti slapukus privalomus tinkamam svetainės ir jos funkcijų veikimui (BDAR 6 str. 1 d. f p.);</li>
                           <li>mes remiamės Jūsų sutikimu analitinių ir reklaminių slapukų naudojimui (BDAR 6 str. 1 d. a p.).</li>
                        </ul>
                        <h3>6. Ar dalinatės mano informacija su kitais subjektais?</h3>
                        <p>Informacija galime dalintis su mūsų paslaugų teikėjais, teikiančias mums IT, svetainės priežiūros ir palaikymo paslaugas, interneto svetainės prieglobos (angl.<em> hosting</em>) paslaugas.</p>
                        <h3>7. Kiek laiko saugote informaciją apie mane?</h3>
                        <p>Informaciją susijusią su slapukais saugome kaip tai nurodyta <a href="#cookie-policy">slapukų politikoje</a>.</p>
                        <h3>8. Kokių veiksmų galiu imtis dėl savo informacijos Jūsų bendrovėje?</h3>
                        <p>Jei norite imtis žemiau nurodytų veiksmų, pra&scaron;ome kreiptis į mus, kaip tai nurodyta 9 skyriuje. Pra&scaron;ome atkreipti dėmesį, jog &scaron;ioms teisėms taikomos įstatymų numatytos sąlygos ir i&scaron;imtys.</p>
                        <ul>
                           <li><strong>Pateikti pra&scaron;ymą susipažinti su turima informacija apie Jus, jei tvarkome Jūsų asmens duomenis, i&scaron; kurių galime nustatyti Jūsų tapatybę;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;taisyti ar papildyti turimą informaciją apie Jus;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;trinti apie Jus, kai:</strong>
                            <ul>
                                <li><strong>Jūsų duomenis tvarkome sutikimo pagrindu;</strong></li>
                                <li><strong>Jūsų duomenis tvarkome neteisėtai;</strong></li>
                                <li><strong>Jūsų duomenys tvarkomi mūsų teisėto intereso pagrindu ir Jūs nuginčijate mūsų teisėtą interesą;</strong></li>
                                <li><strong>Jūsų duomenys nebėra reikalingi, kad būtų pasiekti tikslai, kuriems jie buvo renkami;</strong></li>
                                <li><strong>mums taikoma teisinė prievolė i&scaron;trinti informaciją apie Jus;</strong></li>
                            </ul>
                           </li>
                           <li><strong>pateikti mums pra&scaron;ymą apriboti apie Jus turimos informacijos tvarkymą kai ginčijate duomenų tikslumą ar prie&scaron;taraujate duomenų tvarkymui, nesutinkate, kad būtų i&scaron;trinti neteisėtai tvarkomi Jūsų duomenys, ar duomenų Jums reikia, siekiant pareik&scaron;ti, vykdyti arba apginti teisinius reikalavimus</strong><strong>;</strong></li>
                           <li><strong>nesutikti su Jūsų informacijos rinkimu, naudojimu ir saugojimu mūsų bendrovėje, kai tvarkydami Jūsų duomenis vadovaujamės teisėtų interesu kaip duomenų tvarkymo pagrindu;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;eksportuoti Jūsų duomenis jei duomenis mums pateikėte susistemintu, įprastai naudojamu formatu ir davėte sutikimą tokių duomenų tvarkymui arba turime tvarkyti &scaron;iuos duomenis siekdami įvykdyti sutartį su Jumis;</strong></li>
                           <li><strong>Bet kuriuo metu at&scaron;aukti sutikimą, kurį davėte Jūsų asmens duomenų tvarkymui (tai galite padaryti pakeitę nar&scaron;yklės nustatymus &ndash; paspaudę </strong><a href="https://www.lifewire.com/how-to-delete-cookies-2617981"><strong>ant &scaron;ios nuorodos</strong></a><strong> galite rasti instrukcijas, kaip tai padaryti populiariausiose interneto nar&scaron;yklėse);</strong></li>
                           <li><strong>pateikti skundą Valstybinei duomenų apsaugos inspekcijai (daugiau informacijos </strong><a href="https://vdai.lrv.lt/"><strong>lrv.lt</strong></a><strong>).</strong></li>
                        </ul>
                        <h3>9. Kaip galite man padėti?</h3>
                        <p>Jeigu Jūs turite klausimų, komentarų ar nusiskundimų, susijusių su tuo, kaip mes renkame, naudojame ir saugome duomenis apie Jus, mes esame pasirengę Jums padėti. Jei Jums reikalinga mūsų pagalba, pra&scaron;ome kreiptis el. pa&scaron;tu info@deklaruok24.lt. <strong><br /></strong></p>
                        <h2 id="cookie-policy">TREVIO UAB SLAPUKŲ POLITIKA</h2>
                        <p><strong>Paskutinio atnaujinimo data: 2021-11-18</strong></p>
                        <h3>1. Kas yra slapukai?</h3>
                        <p>Slapukai yra maži tekstiniai failai, saugomi Jūsų įrenginio (pvz., kompiuterio, mobiliojo telefono, plan&scaron;etės) nar&scaron;yklėje, kai Jūs nar&scaron;ote interneto svetainėse.&nbsp;Kitos technologijos, įskaitant duomenis, kuriuos i&scaron;saugome Jūsų interneto nar&scaron;yklėje ar įrenginyje, su Jūsų įrenginiu susijusius identifikatorius bei kitą programinę įrangą, naudojamos pana&scaron;iais tikslais. Slapukai plačiai naudojami, kad svetainės veiktų arba veiktų geriau ir veiksmingiau. &Scaron;ioje politikoje visos minėtos technologijos vadinamos &bdquo;slapukais&ldquo;.&nbsp;</p>
                        <h3>2. Kodėl jūs naudojate slapukus?</h3>
                        <p>Mes naudojame slapukus:</p>
                        <ul>
                           <li>nuolat tobulinti svetainę, kad jį būtų jums dar patrauklesnė;</li>
                        </ul>
                        <h3>3. Kokių tipų slapukai gali būti?</h3>
                        <ul>
                           <li>Griežtai privalomi slapukai</li>
                        </ul>
                        <p>&Scaron;ie slapukai svetainėje yra būtini, kad vartotojas galėtų nar&scaron;yti ir naudotis svetainės funkcijomis, pvz., įsiminti formose įvestą informaciją, kai vartotojas pereina nuo vieno puslapio prie kito nar&scaron;ymo seanso metu. Be griežtai privalomų slapukų taptų neįmanoma teikti tam tikras svetainės paslaugas, o svetainė veiktų ne taip sklandžiai, kaip turėtų. &Scaron;ie slapukai nerenka jokios informacijos rinkodaros tikslais ir neįsimena, kur jūs lankėtės internete.</p>
                        <ul>
                           <li>Analitiniai slapukai</li>
                        </ul>
                        <p>Analitiniai slapukai renka informaciją apie svetainės naudojimą ir padeda tobulinti svetainės veikimą. Pavyzdžiui, analitiniai slapukai gali parodyti, kuriuose puslapiuose lankomasi dažniausiai, padėti registruoti svetainėje vykstančius nesklandumus ir parodyti, ar svetainėje rodoma reklama yra veiksminga. Analitiniai slapukai nerenka asmeninės vartotojų informacijos ir visa &scaron;ių slapukų surinkta informacija yra apibendrinta ir anonimi&scaron;ka.</p>
                        <ul>
                           <li>Funkciniai slapukai</li>
                        </ul>
                        <p>Funkciniai slapukai leidžia svetainei įsiminti jūsų pasirinkimus ir pateikti patobulintų bei labiau jūsų poreikiams pritaikytų funkcijų. Funkciniai slapukai taip pat įsimena jūsų padarytus pakeitimus, pvz., tam tikro tinklalapio individualizavimą, taip pat kitais atvejais, pvz., kai žiūrite vaizdo įra&scaron;ą ar mūsų tinklalapyje paliekate komentarą. Funkciniai slapukai neseka jūsų veiksmų kitose svetainėse.</p>
                        <ul>
                           <li>Reklaminiai slapukai</li>
                        </ul>
                        <p>Reklaminiai slapukai naudojami rodyti daugiau įdomių skelbimų, kurie labiau atitinka jūsų interesus, arba apriboti skelbimų skaičių tose pačiose skelbimų parodose jūsų lankomoje svetainėje. &Scaron;is slapukų tipas taip pat naudojamas kampanijos efektyvumui įvertinti. &Scaron;ie slapukai gali būti naudojami siekiant atsiminti, ką veikėte interneto svetainėje.</p>
                        <h3>4. Kokius slapukus naudojame mes?</h3>
                        <p>Savo svetainėje mes naudojame &scaron;iuos slapukus:</p>
                        <div class="table-wrap">
                        <table>
                           <tbody>
                              <tr>
                                 <td width="144">
                                    <p>SLAPUKO KATEGORIJA</p>
                                 </td>
                                 <td width="206">
                                    <p>SLAPUKO PAVADINIMAS</p>
                                 </td>
                                 <td width="142">
                                    <p>SLAPUKO GALIOJIMO LAIKAS</p>
                                 </td>
                                 <td width="235">
                                    <p>SLAPUKO TIKSLAS</p>
                                 </td>
                              </tr>
                              <!--<tr>
                                 <td rowspan="2" width="144">
                                    <p>Griežtai privalomi slapukai</p>
                                 </td>
                                 <td width="206">
                                    <p>[...]</p>
                                 </td>
                                 <td width="142">
                                    <p>[...]</p>
                                 </td>
                                 <td width="235">
                                    <p>[...]</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="206">
                                    <p>[...]</p>
                                 </td>
                                 <td width="142">
                                    <p>[...]</p>
                                 </td>
                                 <td width="235">
                                    <p>[...]</p>
                                 </td>
                              </tr>-->
                              <tr>
                                 <td rowspan="7" width="144">
                                    <p>Analitiniai slapukai</p>
                                 </td>
                                 <td width="206">
                                    <p>_hjAbsoluteSessionInProgress</p>
                                 </td>
                                 <td width="142">
                                    <p>30 – 35 minutės</p>
                                 </td>
                                 <td width="235">
                                    <p>Pirmosios šalies HotJar slapukas naudojamas pirmojo lankytojo svetainės naršymo seanso aptikimui.</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="206">
                                    <p>_hjFirstSeen</p>
                                 </td>
                                 <td width="142">
                                    <p>30 – 35 minutės</p>
                                 </td>
                                 <td width="235">
                                    <p>Pirmosios šalies HotJar slapukas skirtas nustatyti ar HotJar vartotoją mato pirmą kartą, ar ne.</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="206">
                                    <p>_hjTLDTest</p>
                                 </td>
                                 <td width="142">
                                    <p>Iki naršymo sesijos pabaigos (naršyklės uždarymo)</p>
                                 </td>
                                 <td width="235">
                                    <p>Pirmosios šalies HotJar slapukas, skirtas nustatyti geriausiam HotJar slapukų panaudojimui. Tai daroma, kad slapukai galėtų veiktų svetainės subdomenuose.</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="206">
                                    <p>_hjid</p>
                                 </td>
                                 <td width="142">
                                    <p>1 metai</p>
                                 </td>
                                 <td width="235">
                                    <p>Pirmosios šalies HotJar slapukas, skirtas unikalaus ID suteikimui kiekvienam unikaliam svetainės lankytojui.</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="206">
                                    <p>_ga</p>
                                 </td>
                                 <td width="142">
                                    <p>2 metai</p>
                                 </td>
                                 <td width="235" rowspan="3">
                                    <p>Pirmosios šalies Google slapukai skirti rinkti informaciją apie svetainės lankomumą bei tai, kaip mūsų lankytojai naudojasi interneto svetainė. Slapukai renka tokią informaciją kaip: svetainės lankytojų skaičius, svetainę iš kurios atvyko lankytojai, svetainėje aplankyti puslapiai, naršymui naudojama naršyklė, operacinė sistema ir pan.</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="206">
                                    <p>_gat_gtag_UA_xxxxxxxxx_x</p>
                                 </td>
                                 <td width="142">
                                    <p>1 minutė</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="206">
                                    <p>_gid</p>
                                 </td>
                                 <td width="142">
                                    <p>1 diena</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td rowspan="1" width="144">
                                    <p>Funkciniai slapukai</p>
                                 </td>
                                 <td width="206">
                                    <p>trevioCookie</p>
                                 </td>
                                 <td width="142">
                                    <p>1 metai</p>
                                 </td>
                                 <td width="235">
                                    <p>Lankytojo slapukų nustatymai</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td rowspan="2" width="144">
                                    <p>Reklaminiai slapukai</p>
                                 </td>
                                 <td width="206">
                                    <p>fr</p>
                                 </td>
                                 <td width="142">
                                    <p>90 dienų</p>
                                 </td>
                                 <td width="235">
                                    <p>Trečiosios šalies Facebook slapukas, skirtas reklamų atvaizdavimui, reklamų konversijų matavimui ir atvaizduojamų reklamų aktualumui gerinti.</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="206">
                                    <p>_fbp</p>
                                 </td>
                                 <td width="142">
                                    <p>90 dienų</p>
                                 </td>
                                 <td width="235">
                                    <p>Pirmosios šalies Facebook slapukas, naudojamas lankytojo naršyklės nustatymui reklamų atvaizdavimo ir svetainės analitikos tikslais.</p>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                        </div>
                        <h3>5. Kaip galiu valdyti slapukus?</h3>
                        <p>Galite kontroliuoti slapukų naudojimą, pakeitę nar&scaron;yklės nustatymus. Dėl daugiau informacijos pra&scaron;ome patikrinti naudojamos nar&scaron;yklės kūrėjo interneto puslapį. Taip pat, paspaudę <a href="https://www.lifewire.com/how-to-delete-cookies-2617981">ant &scaron;ios nuorodos</a> galite rasti instrukcijas, kaip tai padaryti populiariausiose interneto nar&scaron;yklėse.</p>
                        <p>Atkreipkite dėmesį, kad trindami slapukus arba i&scaron;jungdami slapukų naudojimą ateityje, galite nepasiekti tam tikrų mūsų svetainės dalių ar funkcijų. Jei pakeisite slapukų nustatymus, tai paveiks ir kitas jūsų lankomas svetaines.<strong><br /></strong></p>
                        <h2 id="privacy-policy-for-inquirer">TREVIO UAB PRIVATUMO POLITIKA ASMENIMS SIUNČIANTIEMS PAKLAUSIMUS, PRA&Scaron;YMUS, SKUNDUS</h2>
                        <h3>Paskutinio atnaujinimo data: 2021-11-18</h3>
                        <p>Trevio UAB rūpinasi Jūsų informacijos apsauga. Mes laikomės Europos Sąjungos Bendrojo duomenų apsaugos reglamento (BDAR) bei kitų įstatymų, saugančių Jūsų informaciją, kurią renkame, naudojame ir saugome savo Bendrovėje.</p>
                        <h3>1. Kaip turėčiau skaityti &scaron;ią Privatumo politiką?</h3>
                        <p>&Scaron;ioje Privatumo politikoje bus atsakyta į svarbiausius klausimus apie tai, kaip mes renkame, naudojame ir saugome informaciją apie Jus. Jei turite kokių nors klausimų arba bet kuri i&scaron; &scaron;io prane&scaron;imo dalis yra neai&scaron;ki, mes esame pasirengę Jums padėti, kaip apra&scaron;yta &scaron;ios Privatumo politikos 9 skyriuje. Pra&scaron;ome atkreipti dėmesį, kad bet kokia žodžio &bdquo;mes&ldquo; forma &scaron;ioje Privatumo politikoje rei&scaron;kia mūsų Bendrovę, kaip nurodyta Privatumo politikos 2 skyriuje.</p>
                        <h3>2. Kas yra atsakingas už mano informacijos apsaugą?</h3>
                        <p>Mes esame: Trevio UAB;</p>
                        <p>Mūsų juridinio asmens kodas yra: 305433599;</p>
                        <p>Mūsų adresas: Naujoji 124-801, Alytus, LT62175;</p>
                        <p>El. pa&scaron;to adresas: info@deklaruok24.lt;</p>
                        <h3>3. Kodėl renkate informaciją apie mane? Koks yra informacijos apie mane rinkimo, naudojimo ir saugojimo teisinis pagrindas?</h3>
                        <div class="table-wrap">
                        <table>
                           <tbody>
                              <tr>
                                 <td colspan="2" width="348">
                                    <p><strong>Duomenų rinkimo, naudojimo, saugojimo tikslas</strong></p>
                                 </td>
                                 <td colspan="2" width="384">
                                    <p><strong>Duomenų rinkimo, naudojimo, saugojimo teisinis pagrindas</strong></p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="336">
                                    <p>&middot; kad galėtumėme tinkamai administruoti gautas užklausas, pra&scaron;ymus ir skundus, rengti atsakymus į juos</p>
                                 </td>
                                 <td colspan="2" width="24">
                                    <p>-</p>
                                 </td>
                                 <td width="372">
                                    <p>mes turime teisėtą interesą administruoti gaunamus pra&scaron;ymus, skundus, paklausimus bei rengti atsakymus į juos (BDAR 6 str. 1 d. f p.), o kiek tokie pra&scaron;ymai, paklausimai, skundai susiję su sudarytos sutarties vykdymu ar noru sudaryti sutartį &ndash; tokių pra&scaron;ymų, paklausimų ar skundų administravimas būtinas mūsų sudarytų sutarčių tinkamam vykdymui ar galimybės sudaryti su Jumis sutartį įvertinimui (BDAR 6 str. 1 d. b p.);</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="336">
                                    <p>&middot; mums taikoma teisinė prievolė saugoti bendrovės veiklos dokumentus</p>
                                 </td>
                                 <td colspan="2" width="24">
                                    <p>-</p>
                                 </td>
                                 <td width="372">
                                    <p>Jūsų asmens duomenys reikalingi mums taikomų teisinių prievolių bendrovės veiklos dokumentų archyvavimo srityje (BDAR 6 str. 1 d. c p.);</p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="336">
                                    <p>&middot; savo teisėtų interesu gynybai &ndash; jei tai būtų reikalinga, Jūsų asmens duomenis galime panaudoti gindami savo teisėtus interesus, įskaitant reputaciją, teismuose, ikiteisminėse ginčų sprendimo institucijose bei kitose kompetentingose institucijose</p>
                                 </td>
                                 <td colspan="2" width="24">
                                    <p>-</p>
                                 </td>
                                 <td width="372">
                                    <p>mes turime teisėtą interesą ginti savo teises bei interesus teismuose, arbitražuose ir ikiteisminėse ginčų nagrinėjimo institucijose (BDAR 6 str. 1 d. f p.).</p>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                        </div>
                        <h3>4. Kokią informaciją turėčiau Jums pateikti ir kodėl?</h3>
                        <p>Pateikdami paklausimą mūsų svetainėje nurodytais kontaktiniais el. pa&scaron;to adresais, per interneto svetainės tiesioginio pokalbio funkcionalumą (angl. <em>chat bubble</em>) ar pa&scaron;tu turėtumėte mums nurodyti savo vardą, pavardę, el. pa&scaron;to adresą ar kitą kontaktinį duomenį, kuriuo pageidaujate gauti atsakymą, o taip pat, paklausimo temą bei paklausimui aktualią informaciją. Pateikus paklausimą, Jūsų gali būti pra&scaron;oma pateikti papildomos informacijos apie Jus, kad galėtume tinkamai atsakyti į Jūsų paklausimą.</p>
                        <h3>5. Ar Jūs renkate jautrią informacija apie mane?</h3>
                        <p>Jautri informacija apie Jus nėra renkama ir, jei ji nėra aktuali Jūsų pateiktam ar planuojamam pateikti skundui, pra&scaron;ymui ar užklausai, pra&scaron;ome jos neteikti. Jei vis dėl to tokia informacija bus pateikta, laikysime, kad davėte mums sutikimą &scaron;ios informacijos tvarkymui (BDAR 9 str. 2 d. a p.).</p>
                        <h3>6. Ar dalinatės mano informacija su kitais subjektais?</h3>
                        <p>Informacija apie Jus gali būti perduota:</p>
                        <ul>
                           <li>teisines paslaugas teikiančioms bendrovėms, advokatų kontoroms, kiek tai reikalinga mūsų teisėtų interesų gynybai;</li>
                           <li>antstoliams, kiek tai reikalinga priteistų sumų i&scaron;ie&scaron;kojimui;</li>
                           <li>mūsų paslaugų teikėjams &ndash; komunikacines (el. pa&scaron;to), svetainės prieglobos (angl. <em>hosting</em>) bei duomenų saugyklų paslaugas mums teikiančioms bendrovėms.</li>
                        </ul>
                        <h3>7. Kiek laiko saugote informaciją apie mane?</h3>
                        <p>Jūsų informacija bus saugoma:</p>
                        <ul>
                           <li>jei jūsų užklausą susijusi su sutartimi kurią esame sudarę ar planuojame sudaryti &ndash; Jūsų informaciją saugosime 10 metų po sutarties pabaigos;</li>
                           <li>jei mums pateikėte skundą, pra&scaron;ymą ar kitokią užklausą, kuri nėra susijusi sus sutarties sudarymu ar vykdymu, ją saugosime vadovaudamiesi Lietuvos vyriausiojo archyvaro patvirtinta Bendrųjų dokumentų saugojimo terminų rodykle &ndash; 1 metus nuo sprendimo mūsų bendrovėje priėmimo;</li>
                           <li>teismams ar kitoms ginčus nagrinėjančioms ar teisėsaugos institucijoms teikiami dokumentai saugomi 1 metus po galutinio sprendimo priėmimo;</li>
                           <li>teismų vykdomieji ra&scaron;tai, antstolių patvarkymai saugomi 10 metų po mokėjimų pabaigos.</li>
                        </ul>
                        <h3>8. Kokių veiksmų galiu imtis dėl savo informacijos Jūsų bendrovėje?</h3>
                        <p>Jei norite imtis žemiau nurodytų veiksmų, pra&scaron;ome kreiptis į mus, kaip tai nurodyta 10 skyriuje. Atkreipiame dėmesį, kad &scaron;ioms teisėms gali būti taikomos įstatymų numatytos i&scaron;imtys bei ribojimai.</p>
                        <ul>
                           <li><strong>Pateikti pra&scaron;ymą susipažinti su turima informacija apie Jus, jei tvarkome Jūsų asmens duomenis, i&scaron; kurių galime nustatyti Jūsų tapatybę;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;taisyti ar papildyti turimą informaciją apie Jus;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;trinti apie Jus, kai:</strong></li>
                           <li><strong>Jūsų duomenis tvarkome sutikimo pagrindu;</strong></li>
                           <li><strong>Jūsų duomenis tvarkome neteisėtai;</strong></li>
                           <li><strong>Jūsų duomenys tvarkomi mūsų teisėto intereso pagrindu ir Jūs nuginčijate mūsų teisėtą interesą;</strong></li>
                           <li><strong>Jūsų duomenys nebėra reikalingi, kad būtų pasiekti tikslai, kuriems jie buvo renkami;</strong></li>
                           <li><strong>mums taikoma teisinė prievolė i&scaron;trinti informaciją apie Jus;</strong></li>
                           <li><strong>pateikti mums pra&scaron;ymą apriboti apie Jus turimos informacijos tvarkymą kai ginčijate duomenų tikslumą ar prie&scaron;taraujate duomenų tvarkymui, nesutinkate, kad būtų i&scaron;trinti neteisėtai tvarkomi Jūsų duomenys, ar duomenų Jums reikia, siekiant pareik&scaron;ti, vykdyti arba apginti teisinius reikalavimus</strong><strong>;</strong></li>
                           <li><strong>nesutikti su Jūsų informacijos rinkimu, naudojimu ir saugojimu mūsų bendrovėje, kai tvarkydami Jūsų duomenis vadovaujamės teisėtų interesu kaip duomenų tvarkymo pagrindu;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;eksportuoti Jūsų duomenis jei duomenis mums pateikėte susistemintu, įprastai naudojamu formatu ir davėte sutikimą tokių duomenų tvarkymui arba turime tvarkyti &scaron;iuos duomenis siekdami įvykdyti sutartį su Jumis;</strong></li>
                           <li><strong>bet kuriuo metu at&scaron;aukti Jūsų asmens duomenų tvarkymui duotą sutikimą</strong><strong>;</strong></li>
                           <li><strong>pateikti skundą Valstybinei duomenų apsaugos inspekcijai (daugiau informacijos </strong><a href="https://vdai.lrv.lt/"><strong>lrv.lt</strong></a><strong>).</strong></li>
                        </ul>
                        <h3>9. Kaip galite man padėti?</h3>
                        <p>Jeigu Jūs turite klausimų, komentarų ar nusiskundimų, susijusių su tuo, kaip mes renkame, naudojame ir saugome duomenis apie Jus, mes esame pasirengę Jums padėti. Jei Jums reikalinga mūsų pagalba, pra&scaron;ome kreiptis el. pa&scaron;tu info@deklaruok24.lt.</p>
                        <h2 id="direct-marketing-privacy-policy">TREVIO UAB TIESIOGINĖS RINKODAROS PRIVATUMO POLITIKA</h2>
                        <h3>Paskutinio atnaujinimo data: 2021-11-18</h3>
                        <p>Trevio UAB rūpinasi Jūsų informacijos apsauga. Mes laikomės Europos Sąjungos Bendrojo duomenų apsaugos reglamento (BDAR) bei kitų įstatymų, saugančių Jūsų informaciją, kurią renkame, naudojame ir saugome savo Bendrovėje.</p>
                        <h3>Kaip turėčiau skaityti &scaron;ią Privatumo politiką?</h3>
                        <p>&Scaron;ioje Privatumo politikoje bus atsakyta į svarbiausius klausimus apie tai, kaip mes renkame, naudojame ir saugome informaciją apie Jus. Jei turite kokių nors klausimų arba bet kuri i&scaron; &scaron;io prane&scaron;imo dalis yra neai&scaron;ki, mes esame pasirengę Jums padėti, kaip apra&scaron;yta &scaron;ios Privatumo politikos 7 skyriuje. Pra&scaron;ome atkreipti dėmesį, kad bet kokia žodžio &bdquo;mes&ldquo; forma &scaron;ioje Privatumo politikoje rei&scaron;kia mūsų Bendrovę, kaip nurodyta Privatumo politikos 2 skyriuje.</p>
                        <h3>2. Kas yra atsakingas už mano informacijos apsaugą?</h3>
                        <p>Mes esame: Trevio UAB;</p>
                        <p>Mūsų juridinio asmens kodas yra: 305433599;</p>
                        <p>Mūsų adresas: Naujoji 124-801, Alytus, LT62175;</p>
                        <p>El. pa&scaron;to adresas: info@deklaruok24.lt;</p>
                        <h3>3. Kodėl renkate informaciją apie mane? Koks yra informacijos apie mane rinkimo, naudojimo ir saugojimo teisinis pagrindas?</h3>
                        <div class="table-wrap">
                        <table>
                           <tbody>
                              <tr>
                                 <td colspan="2" width="349">
                                    <p><strong>Duomenų rinkimo, naudojimo, saugojimo tikslas</strong></p>
                                 </td>
                                 <td colspan="2" width="383">
                                    <p><strong>Duomenų rinkimo, naudojimo, saugojimo teisinis pagrindas</strong></p>
                                 </td>
                              </tr>
                              <tr>
                                 <td width="336">
                                    <p>&middot; kad galėtumėme el. pa&scaron;tu Jums reklamuoti savo teikiamas paslaugas, siųsti mūsų pasiūlymus, naujienlai&scaron;kius</p>
                                 </td>
                                 <td colspan="2" width="24">
                                    <p>-</p>
                                 </td>
                                 <td width="372">
                                    <p>&Scaron;iam tikslui pasiekti me remiamės Jūsų sutikimu (BDAR 6 str. 1 d. a p.)</p>
                                 </td>
                              </tr>
                           </tbody>
                        </table>
                        </div>
                        <h3>4. Ar dalinatės mano informacija su kitais subjektais?</h3>
                        <p>Informacija apie Jus gali būti perduodama mūsų paslaugų teikėjams &ndash; el. pa&scaron;to rinkodaros platformų, duomenų saugyklų paslaugų teikėjams.</p>
                        <h3>5. Kiek laiko saugosite informaciją apie mane?</h3>
                        <p>Informaciją apie Jus saugosime 3 metus arba iki sutikimo at&scaron;aukimo. Atkreipiame dėmesį, kad baigiantis numatytam trijų metų laikotarpiui galime papra&scaron;yti Jūsų pratęsti sutikimą ilgesniam laikotarpiui.</p>
                        <h3>6. Kokios mano teisės?</h3>
                        <p>Jei norite imtis žemiau nurodytų veiksmų, pra&scaron;ome kreiptis į mus, kaip tai nurodyta 7 skyriuje. Atkreipiame dėmesį, kad &scaron;ioms teisėms gali būti taikomos teisės aktų numatytos i&scaron;imtys bei ribojimai.</p>
                        <ul>
                           <li><strong>Pateikti pra&scaron;ymą susipažinti su turima informacija apie Jus, jei tvarkome Jūsų asmens duomenis, i&scaron; kurių galime nustatyti Jūsų tapatybę;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;taisyti ar papildyti turimą informaciją apie Jus;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;trinti apie Jus, kai:</strong></li>
                           <li><strong>Jūsų duomenis tvarkome sutikimo pagrindu;</strong></li>
                           <li><strong>Jūsų duomenis tvarkome neteisėtai;</strong></li>
                           <li><strong>Jūsų duomenys tvarkomi mūsų teisėto intereso pagrindu ir Jūs nuginčijate mūsų teisėtą interesą;</strong></li>
                           <li><strong>Jūsų duomenys nebėra reikalingi, kad būtų pasiekti tikslai, kuriems jie buvo renkami;</strong></li>
                           <li><strong>mums taikoma teisinė prievolė i&scaron;trinti informaciją apie Jus;</strong></li>
                           <li><strong>pateikti mums pra&scaron;ymą apriboti apie Jus turimos informacijos tvarkymą kai ginčijate duomenų tikslumą ar prie&scaron;taraujate duomenų tvarkymui, nesutinkate, kad būtų i&scaron;trinti neteisėtai tvarkomi Jūsų duomenys, ar duomenų Jums reikia, siekiant pareik&scaron;ti, vykdyti arba apginti teisinius reikalavimus</strong><strong>;</strong></li>
                           <li><strong>pateikti pra&scaron;ymą i&scaron;eksportuoti Jūsų duomenis jei duomenis mums pateikėte susistemintu, įprastai naudojamu formatu ir davėte sutikimą tokių duomenų tvarkymui arba turime tvarkyti &scaron;iuos duomenis siekdami įvykdyti sutartį su Jumis;</strong></li>
                           <li><strong>bet kuriuo metu at&scaron;aukti sutikimą Jūsų asmens duomenų tvarkymui;</strong></li>
                           <li><strong>pateikti skundą Valstybinei duomenų apsaugos inspekcijai (daugiau informacijos </strong><a href="https://vdai.lrv.lt/"><strong>lrv.lt</strong></a><strong>).</strong></li>
                        </ul>
                        <p><strong>Atkreipiame dėmesį, kad negalite pasinaudoti teise nesutikti su Jūsų asmens duomenų tvarkymu, kadangi &scaron;ia teise galima pasinaudoti tik tais atvejais, kai asmens duomenys tvarkomi teisėto intereso pagrindu (BDAR </strong><strong>6 str. 1 d. f p.), o </strong><strong>mes Jūsų asmens duomenų tvarkymui remiamės Jūsų sutikimu (BDAR </strong><strong>6 str. 1 d. a p.).</strong></p>
                        <h3>7. Kaip galite man padėti?</h3>
                        <p>Jeigu Jūs turite klausimų, komentarų ar nusiskundimų, susijusių su tuo, kaip mes renkame, naudojame ir saugome duomenis apie Jus, mes esame pasirengę Jums padėti. Jei Jums reikalinga mūsų pagalba, pra&scaron;ome kreiptis el. pa&scaron;tu info@deklaruok24.lt.</p>
                        <h2 id="privacy-policy-for-broker-customers">TREVIO UAB PRIVATUMO POLITIKA SIUNTŲ I&Scaron;MUITINIMUI TVARKOMIEMS ASMENS DUOMENIMS</h2>
                        <h3>Paskutinio atnaujinimo data: 2021-11-18</h3>
                        <p>Trevio UAB rūpinasi Jūsų informacijos apsauga. Mes laikomės Europos Sąjungos Bendrojo duomenų apsaugos reglamento (BDAR) bei kitų įstatymų, saugančių Jūsų informaciją, kurią renkame, naudojame ir saugome savo Bendrovėje.</p>
                        <h3>1. Kaip turėčiau skaityti &scaron;į prane&scaron;imą?</h3>
                        <p>&Scaron;ioje Privatumo politikoje bus atsakyta į svarbiausius klausimus apie tai, kaip mes renkame, naudojame ir saugome informaciją apie Jus. Jei turite kokių nors klausimų arba bet kuri i&scaron; &scaron;io prane&scaron;imo dalis yra neai&scaron;ki, mes esame pasirengę Jums padėti, kaip apra&scaron;yta &scaron;ios Privatumo politikos 9 skyriuje. Pra&scaron;ome atkreipti dėmesį, kad bet kokia žodžio &bdquo;mes&ldquo; forma &scaron;ioje Privatumo politikoje rei&scaron;kia mūsų Bendrovę, kaip nurodyta Privatumo politikos 2 skyriuje.</p>
                        <h3>2. Kas yra atsakingas už mano informacijos apsaugą?</h3>
                        <p>Tvarkydami asmens duomenis siuntų i&scaron;muitinimo tikslu, mes veikiame kaip savo klientų duomenų tvarkytojai. Duomenų valdytojas, kuris yra atsakingas už Jūsų informacijos apsauga, paprastai yra siuntos/-ų vežėjas. BDAR neįpareigoja mūsų vie&scaron;ai skelbti klientus, kurių vardu ir interesais mes tvarkome asmens duomenis. Tačiau, jei turite klausimų, pra&scaron;ymų ar nusiskundimų, susijusių su Jūsų asmens duomenų tvarkymu, galite kreiptis į mus, žemiau nurodytais kontaktais, o mes Jūsų užklausą perduosime mūsų klientui, kuris yra atsakingas už Jūsų asmens duomenų apsaugą. Atkreipiame dėmesį, kad tam tikrais atvejais, galime papra&scaron;yti Jūsų papildomos informacijos, kad galėtumėme nustatyti, kam Jūsų paklausimą turime perduoti.</p>
                        <p>Mūsų kontaktai:</p>
                        <p>Mes esame: Trevio UAB;</p>
                        <p>Mūsų juridinio asmens kodas yra: 305433599;</p>
                        <p>Mūsų adresas: Naujoji 124-801, Alytus, LT62175;</p>
                        <p>El. pa&scaron;to adresas: info@deklaruok24.lt;</p>
                        <h3>3. Kokią informaciją apie Jus mes gauname?</h3>
                        <p>I&scaron; savo klientų mes gauname &scaron;ią informaciją apie Jus:</p>
                        <ul>
                           <li>identifikacinius duomenis (vardą, pavardę);</li>
                           <li>kontaktinius duomenis (adresas, el. pa&scaron;to adresas, telefono numeris);</li>
                           <li>duomenys apie siuntą (pardavėjo pateikta informaciją apie prekę, t. y. prekė, jos kaina, siuntos siuntėjas, siuntos statusas, siuntos svoris ir pan.).</li>
                        </ul>
                        <p>Atkreipiame dėmesį, kad jei pardavėjui nepateikėte kokios nors informacijos, pvz.: el. pa&scaron;to adreso, tokiu atveju tokios informacijos neturėsime ir mes.</p>
                        <h3>4. Kiek laiko saugote informaciją apie mane? </h3>
                        <p>Kaip minėta 2 punkte, mums tvarkant Jūsų asmens duomenis, mes tvarkydami Jūsų asmens duomenis veikiame kaip duomenų tvarkytojas. Duomenų valdytojas (subjektas, kuris yra atsakingas už Jūsų asmens duomenų apsaugą) nustato Jūsų asmens duomenų saugojimo terminą, pagal kurį mes saugome mums perduotus asmens duomenis. Taigi, rinkdami, naudodami ir saugodami asmens duomenis, mes remiamės mūsų kliento (duomenų valdytojo) pateiktais nurodymais.</p>
                        `
                                    }}
                                />
                            </TextBlock>
                            {/*}
                    <TextBlock className="mb-9 m:mb-12">
                        <p>
                            Trevio UAB rūpinasi Jūsų informacijos apsauga. Mes
                            laikomės Europos Sąjungos Bendrojo duomenų apsaugos
                            reglamento (BDAR) bei kitų įstatymų, saugančių Jūsų
                            informaciją, kurią renkame, naudojame ir saugome
                            savo Bendrovėje.
                        </p>
                    </TextBlock>
                    <Heading
                        text="1. Privatumo politika"
                        className="mb-3"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-9 m:mb-12">
                        <p>
                            Mūsų privatumo politika atsakys į svarbiausius
                            klausimus apie tai, kaip mes renkame, naudojame ir
                            saugome informaciją apie Jus. Jei turite klausimų,
                            mes esame pasirengę Jums padėti, kaip aprašyta
                            toliau.
                        </p>
                        <p>
                            Prašome atidžiai perskaityti mūsų Privatumo
                            politikas:
                        </p>
                    </TextBlock>
                    <Heading
                        text="2. Mūsų kontaktai"
                        className="mb-3"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-9 m:mb-12">
                        <p>
                            Jei turite klausimų, komentarų ar skundų dėl to,
                            kaip mes renkame, naudojame ir saugome informaciją
                            apie jus, mes esame pasirengę Jums padėti. Jeigu
                            Jums reikalinga mūsų pagalba, prašome kreiptis el.
                            paštu info@deklaruok24.lt.
                        </p>
                    </TextBlock>
                    <Heading
                        text="3. Mano teisės"
                        className="mb-3"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-12">
                        <p>
                            Jei norite imtis žemiau nurodytų veiksmų, prašome
                            kreiptis į mus antrame punkte nurodytais kontaktais.
                            Prašome atkreipti dėmesį, jog šioms teisėms taikomos
                            įstatymų numatytos sąlygos ir išimtys:
                        </p>
                        <ul>
                            <li>
                                pateikti prašymą atskleisti apie Jus turimą
                                informaciją;
                            </li>
                            <li>
                                pateikti prašymą ištaisyti turimą informaciją
                                apie Jus;
                            </li>
                            <li>
                                pateikti prašymą ištrinti turimą informaciją
                                apie Jus;
                            </li>
                            <li>
                                pateikti prašymą apriboti prieigą prie turimos
                                informacijos apie Jus ar jos ištrynimą;
                            </li>
                            <li>
                                nesutikti su Jūsų informacijos rinkimu,
                                naudojimu ir saugojimu mūsų bendrovėje;
                            </li>
                            <li>
                                pateikti prašymą išeksportuoti Jūsų duomenis
                                arba perkelti juos į kitą bendrovę;
                            </li>
                            <li>
                                pateikti skundą Valstybinei duomenų apsaugos
                                inspekcijai (daugiau informacijos vdai.lrv.lt).
                            </li>
                        </ul>
                    </TextBlock>
                    <Heading
                        text="TREVIO UAB PRIVATUMO POLITIKA INTERNETO SVETAINĖS LANKYTOJAMS"
                        className="mb-3"
                        size="xs"
                        component="h2"
                    />
                    <Heading
                        text="Paskutinio atnaujinimo data: 2021-11-18"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>
                            Trevio UAB rūpinasi Jūsų informacijos apsauga. Mes
                            laikomės Europos Sąjungos Bendrojo duomenų apsaugos
                            reglamento (BDAR) bei kitų įstatymų, saugančių Jūsų
                            informaciją, kurią renkame, naudojame ir saugome
                            savo Bendrovėje.
                        </p>
                    </TextBlock>
                    <Heading
                        text="1. Kaip turėčiau skaityti šią Privatumo politiką?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>
                            Šioje Privatumo politikoje bus atsakyta į
                            svarbiausius klausimus apie tai, kaip mes renkame,
                            naudojame ir saugome informaciją apie Jus. Jei
                            turite kokių nors klausimų arba bet kuri iš šio
                            pranešimo dalis yra neaiški, mes esame pasirengę
                            Jums padėti, kaip aprašyta šios Privatumo politikos
                            10 skyriuje. Prašome atkreipti dėmesį, kad bet kokia
                            žodžio „mes“ forma šioje Privatumo politikoje
                            reiškia mūsų Bendrovę, kaip nurodyta Privatumo
                            politikos 2 skyriuje.
                        </p>
                    </TextBlock>
                    <Heading
                        text="2. Kas yra atsakingas už mano informacijos apsaugą? "
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>
                            Mes esame: Trevio UAB;
                            <br />
                            Mūsų juridinio asmens kodas yra: 305433599;
                            <br />
                            Mūsų adresas: Naujoji 124-801, Alytus, LT62175;
                            <br />
                            El. pašto adresas: info@deklaruok24.lt;
                            <br />
                            Tel. Nr.: [...].
                        </p>
                    </TextBlock>
                    <Heading
                        text="3. Kodėl renkate informaciją apie mane?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>
                            Mes teikiame viešą prieigą prie interneto svetainės
                            deklaruok24.lt, ją palaikome bei tobuliname,
                            užtikriname tinkamą jos funkcijų veikimą. Dėl šių
                            priežasčių mes naudojame slapukus. Daugiau
                            informacijos apie mūsų interneto puslapyje
                            naudojamus slapukus ir jų paskirtį galite rasti
                            slapukų politikoje.
                        </p>
                    </TextBlock>
                    <Heading
                        text="4. Ar naudojate slapukus?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>
                            Taip. Mes savo interneto svetainėje [svetainės
                            adresas] naudojame slapukus, kaip nurodyta Slapukų
                            politikoje.
                        </p>
                        <p>
                            Mes neturime galimybės naudoti slapukų savo
                            socialinio tinklų paskyrose, tačiau patys
                            socialiniai tinklai, kuriuose mes turime paskyras,
                            juos naudoja. Daugiau informacijos apie tai, kaip
                            mūsų naudojamų socialinių tinklų valdytojai renka,
                            naudoja ir saugo informaciją apie Jus galite rasti
                            paspaudę žemiau esančias nuorodas:
                        </p>
                        <p>
                            <a
                                href="https://www.facebook.com/policy.php"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i>Facebook</i> privatumo politika;
                            </a>
                            <a
                                href="https://help.instagram.com/519522125107875"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <i>Instagram</i> privatumo politika.
                            </a>
                        </p>
                    </TextBlock>
                    <Heading
                        text="5. Koks yra teisinis informacijos apie mane rinkimo pagrindas?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>Mes renkame informaciją apie Jus teisėtai, nes:</p>
                        <ul>
                            <li>
                                mes turime teisėtą interesą naudoti slapukus
                                privalomus tinkamam svetainės ir jos funkcijų
                                veikimui (BDAR 6 str. 1 d. f p.);
                            </li>
                            <li>
                                mes remiamės Jūsų sutikimu analitinių ir
                                reklaminių slapukų naudojimui (BDAR 6 str. 1 d.
                                a p.).
                            </li>
                        </ul>
                    </TextBlock>
                    <Heading
                        text="6. Ar dalinatės mano informacija su kitais subjektais?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>Mes renkame informaciją apie Jus teisėtai, nes:</p>
                        <ul>
                            <li>
                                Informacija galime dalintis su mūsų paslaugų
                                teikėjais, teikiančias mums IT, svetainės
                                priežiūros ir palaikymo paslaugas, interneto
                                svetainės prieglobos (angl. <i>hosting</i>)
                                paslaugas.
                            </li>
                            <li>
                                mes remiamės Jūsų sutikimu analitinių ir
                                reklaminių slapukų naudojimui (BDAR 6 str. 1 d.
                                a p.).
                            </li>
                        </ul>
                    </TextBlock>
                    <Heading
                        text="7. Kiek laiko saugote informaciją apie mane?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>
                            Informaciją susijusią su slapukais saugome kaip tai
                            nurodyta slapukų politikoje.
                        </p>
                    </TextBlock>
                    <Heading
                        text="8. Kokių veiksmų galiu imtis dėl savo informacijos Jūsų bendrovėje?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>
                            Jei norite imtis žemiau nurodytų veiksmų, prašome
                            kreiptis į mus, kaip tai nurodyta 9 skyriuje.
                            Prašome atkreipti dėmesį, jog šioms teisėms taikomos
                            įstatymų numatytos sąlygos ir išimtys.
                        </p>
                        <ul>
                            <li>
                                Pateikti prašymą susipažinti su turima
                                informacija apie Jus, jei tvarkome Jūsų asmens
                                duomenis, iš kurių galime nustatyti Jūsų
                                tapatybę;
                            </li>
                            <li>
                                pateikti prašymą ištaisyti ar papildyti turimą
                                informaciją apie Jus;
                            </li>
                            <li>
                                pateikti prašymą ištrinti apie Jus, kai:
                                <ul>
                                    <li>
                                        Jūsų duomenis tvarkome sutikimo
                                        pagrindu;
                                    </li>
                                    <li>Jūsų duomenis tvarkome neteisėtai;</li>
                                    <li>
                                        Jūsų duomenys tvarkomi mūsų teisėto
                                        intereso pagrindu ir Jūs nuginčijate
                                        mūsų teisėtą interesą;
                                    </li>
                                    <li>
                                        Jūsų duomenys nebėra reikalingi, kad
                                        būtų pasiekti tikslai, kuriems jie buvo
                                        renkami;
                                    </li>
                                    <li>
                                        mums taikoma teisinė prievolė ištrinti
                                        informaciją apie Jus;
                                    </li>
                                </ul>
                            </li>
                            <li>
                                pateikti mums prašymą apriboti apie Jus turimos
                                informacijos tvarkymą kai ginčijate duomenų
                                tikslumą ar prieštaraujate duomenų tvarkymui,
                                nesutinkate, kad būtų ištrinti neteisėtai
                                tvarkomi Jūsų duomenys, ar duomenų Jums reikia,
                                siekiant pareikšti, vykdyti arba apginti
                                teisinius reikalavimus;
                            </li>
                            <li>
                                nesutikti su Jūsų informacijos rinkimu,
                                naudojimu ir saugojimu mūsų bendrovėje, kai
                                tvarkydami Jūsų duomenis vadovaujamės teisėtų
                                interesu kaip duomenų tvarkymo pagrindu;
                            </li>
                            <li>
                                pateikti prašymą išeksportuoti Jūsų duomenis jei
                                duomenis mums pateikėte susistemintu, įprastai
                                naudojamu formatu ir davėte sutikimą tokių
                                duomenų tvarkymui arba turime tvarkyti šiuos
                                duomenis siekdami įvykdyti sutartį su Jumis;
                            </li>
                            <li>
                                Bet kuriuo metu atšaukti sutikimą, kurį davėte
                                Jūsų asmens duomenų tvarkymui (tai galite
                                padaryti pakeitę naršyklės nustatymus – paspaudę
                                ant šios nuorodos galite rasti instrukcijas,
                                kaip tai padaryti populiariausiose interneto
                                naršyklėse);
                            </li>
                            <li>
                                pateikti skundą Valstybinei duomenų apsaugos
                                inspekcijai (daugiau informacijos vdai.lrv.lt).
                            </li>
                        </ul>
                    </TextBlock>
                    <Heading
                        text="9. Kaip galite man padėti?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <TextBlock className="mb-8 m:mb-0">
                        <p>
                            Jeigu Jūs turite klausimų, komentarų ar
                            nusiskundimų, susijusių su tuo, kaip mes renkame,
                            naudojame ir saugome duomenis apie Jus, mes esame
                            pasirengę Jums padėti. Jei Jums reikalinga mūsų
                            pagalba, prašome kreiptis el. paštu info@deklaruok24.lt.
                        </p>
                    </TextBlock>
                    <Heading
                        text="TREVIO UAB SLAPUKŲ POLITIKA"
                        className="mb-3"
                        size="xs"
                        component="h2"
                    />
                    <Heading
                        text="Paskutinio atnaujinimo data: 2021-11-18"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />
                    <Heading
                        text="1. Kas yra slapukai?"
                        className="mb-6 m:mb-6"
                        size="xxs"
                        component="h3"
                    />*/}
                        </Container>
                    </>
                )}
            </Section>
        </Main>
    )
}


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/privacy-policy',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  